import React from 'react';
import Button from '@material-ui/core/Button';
import ButtonBase from '@material-ui/core/ButtonBase';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';

import PropTypes from 'prop-types';

const styles = () => ({
  modalTitle: {
    textAlign: 'center',
    padding: '4px',
    margin: '4px',
  },
});

class ModalImage extends React.Component {
  state = {
    open: false,
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    const { buttonClass, classes, content, title } = this.props;

    return (
      <span className="spanModal">
        <ButtonBase
          size="small"
          classes="flat"
          className={buttonClass}
          onClick={this.handleClickOpen}
        >
          <img src={content} width="24" height="24" />
        </ButtonBase>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="modal-image-title"
          aria-describedby="modal-image-description"
        >
          <DialogTitle className={classes.modalTitle} id="modal-image-title">
            {title}
          </DialogTitle>
          <DialogContent>
            <img src={content} width="300" height="300" />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary" autoFocus>
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </span>
    );
  }
}

ModalImage.propTypes = {
  buttonClass: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
  content: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default withStyles(styles)(ModalImage);



// WEBPACK FOOTER //
// ./src/components/Modal/ModalImage.jsx